var _module_exports = "<iframe id=\"third-party-report-iframe\" frameborder=\"0\" scrolling=\"auto\" height=\"100%\" width=\"100%\"></iframe>";;
var path = '/app/components/third-party-report.component.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;